// @flow strict

import * as React from 'react'
import cx from 'classnames'
import { SectionThemes, SectionWrapper } from '../../SectionWrapper'
import styles from './OverdraftEligibilityChecker.module.scss'
import OverdraftEligibilityCheckerForm from './OverdraftEligibilityCheckerForm'
import { type FormResult, prettyFormResult } from './formTypes'
import { AccessibilityText } from '@mondough/public-web-components'

const EligibilityResult = ({
  status,
  description,
}: {
  status: string,
  description: string,
}) => (
  <div className={styles.eligibilityContainer}>
    {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
    <AccessibilityText as={<h2 />}>Eligibility Results</AccessibilityText>
    <h3 className={styles.eligibilityTitle}>{prettyFormResult[status]}</h3>
    <p className={styles.eligibilityBody}>{description}</p>
    <p className={cx(styles.eligibilityBody, styles.reminder)}>
      {'Remember: these results are not definite, this is just a guide'}
    </p>
  </div>
)

const OverdraftEligibilityCheckerSection = () => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false)
  const [formResult, setResult] = React.useState<?FormResult>(undefined)

  return (
    <>
      <SectionWrapper
        theme={SectionThemes.GREY}
        id="eligibility-checker"
        contentClassName={styles.baseFormContent}
      >
        <div className={styles.formContainer}>
          <h2 className={styles.formSectionTitle}>
            Check if you're eligible for an overdraft
          </h2>
          <p className={cx(styles.formSectionIntro, styles.introP)}>
            You can use this eligibility checker to see if you’re likely to get
            an overdraft with us. Please note a few things:
          </p>
          <ul className={styles.formSectionIntro}>
            <li>
              Using this checker doesn’t guarantee you’ll get an overdraft with
              us
            </li>
            <li>
              The outcome is based solely on the accuracy on the information you
              give us
            </li>
            <li>Using the checker won't affect your credit file in any way</li>
            <li>
              Any overdraft offered by Monzo will depend on a full eligibility
              assessment (this will happen when you apply for an overdraft in
              our app)
            </li>
          </ul>
          <OverdraftEligibilityCheckerForm
            setIsLoading={setIsLoading}
            setResult={setResult}
          />
          {isLoading ? (
            <div className={styles.eligibilityContainer}>
              <div className={styles.spinnerRing}>
                <div />
                <div />
                <div />
                <div />
              </div>
            </div>
          ) : (
            <EligibilityResult
              status={(formResult != null && formResult.eligibility) || ''}
              description={
                (formResult != null && formResult.eligibility_explanation) || ''
              }
            />
          )}
        </div>
      </SectionWrapper>
    </>
  )
}

export const renderOverdraftEligibilityChecker = () => (
  <OverdraftEligibilityCheckerSection />
)

export default OverdraftEligibilityCheckerSection
